import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { CanActivateFn, GuardResult } from '@angular/router';
import { firstValueFrom, isObservable } from 'rxjs';
import { authGuard } from './auth.guard';
import { adminGuard } from './admin.guard';

async function resultOf(result: ReturnType<CanActivateFn>): Promise<GuardResult> {
  return isObservable(result) ? firstValueFrom(result) : result;
}

/** Guard arrays subscribe concurrently. Resolve sign-in before loading permissions. */
export function sequenceAdminGuards(
  authenticate: CanActivateFn,
  authorise: CanActivateFn,
): CanActivateFn {
  return async (route, state) => {
    const injector = inject(EnvironmentInjector);
    const authenticated = await resultOf(authenticate(route, state));
    if (authenticated !== true) return authenticated;
    return resultOf(runInInjectionContext(injector, () => authorise(route, state)));
  };
}

export const authenticatedAdminGuard = sequenceAdminGuards(authGuard, adminGuard);
